import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { MUTATION_KEYS } from './queryKeys'
import { IAdvancedAnalyticsApiPayload } from '../types/chart'
import Api from '../api/Api'

type GetAdvancedAnalyticsResponse = {
  Result?: {
    img: string
    links?: string[]
  }
  Error?: any
}

type AdvancedAnalyticsVariables = {
  payload: IAdvancedAnalyticsApiPayload
  signal?: AbortSignal
}

export default function useGetAdvancedAnalyticsMutation(): UseMutationResult<
  GetAdvancedAnalyticsResponse,
  any,
  AdvancedAnalyticsVariables,
  unknown
> {
  return useMutation({
    mutationKey: [MUTATION_KEYS.chart.getAdvancedAnalytics],
    mutationFn: async ({ payload, signal }: AdvancedAnalyticsVariables) => {
      return await Api.chart.getAdvancedAnalytics(payload, { signal })
    },
  })
}
